<template>
    <div class="seismic-safety-page" v-if="pageSetup != null">
        <seismicSafetyMain></seismicSafetyMain>
        <seismicSafetyNews></seismicSafetyNews>
        <seismicSafetyVideo></seismicSafetyVideo>
        <seismicSafetyQuality></seismicSafetyQuality>
        <seismicSafetyCards></seismicSafetyCards>
        <seismicSafetyTech></seismicSafetyTech>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import seismicSafetyMain from '@/components/seismic-safety/seismic-safety-main.vue'
    import seismicSafetyQuality from '@/components/seismic-safety/seismic-safety-quality.vue'
    import seismicSafetyCards from '@/components/seismic-safety/seismic-safety-cards.vue'
    import seismicSafetyTech from '@/components/seismic-safety/seismic-safety-tech.vue'
    import seismicSafetyNews from '@/components/seismic-safety/seismic-safety-news.vue'
    import seismicSafetyVideo from '@/components/seismic-safety/seismic-safety-video.vue'
	import formPage from '@/components/forms/form-page.vue';	
    export default {
        name: 'new-owners--page',
        components: {
            seismicSafetyMain,
            seismicSafetyQuality,
            seismicSafetyCards,
            seismicSafetyTech,
            seismicSafetyNews,
            seismicSafetyVideo,
            formPage,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSeismicSafetyPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.seismicSafetyPage != null) {
                next(vm => {
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getSeismicSafetyPageData').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 300);
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'seismic-safety';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/seismic-safety/seismic-safety-page.scss';
    @import '@/styles/components/seismic-safety/respond/seismic-safety-page-respond.scss';
    // @import '@/styles/respond/news/news-respond.scss';
</style>